import React from 'react'
import styled from 'styled-components'
import {projectdata} from '../data/Data'
function Project() {
    return (

      <Wrapper>
        <CardsContainer>
          
          {projectdata.map((item,i)=>{
            return (
              <Card key={i}>
              <img src={item.image} alt={item.name}/>
              <h2>{item.name}</h2>
              <p>{item.description}</p>
              <a target="_blank" rel="noreferrer" href={item.link}><button>
                View Live
                </button>
                </a>
              </Card>
              )
            })}

        </CardsContainer>
        



          
      </Wrapper>


    )
}

export default Project

const Wrapper=styled.div`
max-width:100%;
`;

const CardsContainer=styled.div`
display:grid;
grid-template-columns:50% 50%;
place-items:center;
margin-left:10%;
margin-right:10%;

`;

const Card=styled.div`
background-color:whitesmoke;
text-align:center;
margin:10% 0;
height:75vh;
width:30vw;
 h2{
  margin-top:50px;
  letter-spacing:1px;
 }
 img{
   
   /* object-fit:contain; */
   height:40%;
   width:100%;

   
   :hover{
     opacity:0.8;
   }
 }
 p{
   font-size:16px;
  letter-spacing:0.7px;
  word-spacing:5px;
  margin-left:5px;
  margin-right:5px;
  
 }

button{
  font-weight:bold;
  letter-spacing:1px;
  text-transform:uppercase;
  margin:10% 0;
  height:40px;
  width:80%;
  border:none;
  border-radius:5px;
  background:black;
  color:whitesmoke;
  /* transition:all ease-in-out; */
}

button:hover{
  cursor:pointer;
}

  @media screen and (max-width:768px){
    height:90%;
    
    h2{
      margin-top:10px;
      font-size:16px;
    }
    p{
      font-size:12px;
    }
    button{
      font-size:12px;
      height:30px;
      width:90px;
    }
    img{
      height:100px;
    }    
  }
`;